import { message, PageHeader, Select, Space, Spin, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
import "./ReporteConsecutivoFacturacion.css";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

// Tipo de venta que manda el backend en cada fila. El color (mismo hex en
// pantalla y en Excel) solo se aplica cuando el reporte mezcla tipos.
// RF y RR son las siglas con las que el cliente identifica refacturas y
// re-remisiones (facturas que vienen de una remision).
const TIPOS = {
  factura: { label: "Factura", color: null, className: "default" },
  remision: { label: "Remisión", color: "FFF1B8", className: "consecutivo-remision" },
  reRemision: { label: "Re-remisión (RR)", color: "EFDBFF", className: "consecutivo-re-remision" },
  refactura: { label: "Refactura (RF)", color: "FFD6E7", className: "consecutivo-refactura" },
  anticipo: { label: "Anticipo", color: "B5F5EC", className: "consecutivo-anticipo" },
};
const ORDEN_TIPOS = ["factura", "remision", "reRemision", "refactura", "anticipo"];

const tiposPresentes = (facturas) => {
  const presentes = new Set(facturas.map((f) => f.tipo));
  return ORDEN_TIPOS.filter((tipo) => presentes.has(tipo));
};

// Si todas las filas son del mismo tipo el reporte se queda sin colores.
const debeColorear = (facturas) => new Set(facturas.map((f) => f.tipo)).size > 1;

// Orden pedido para el Excel: difiere del de la tabla en pantalla - PROYECTO se
// va al final y CONCEPTO va antes que OBSERVACIONES.
const HEADERS = [
  "ESTATUS",
  "FECHA",
  "FOLIO",
  "RAZON SOCIAL",
  "VENDEDOR",
  "IMPORTE",
  "DESCUENTO",
  "IVA",
  "TOTAL",
  "NC",
  "TOTAL A PAGAR",
  "FECHA DE PAGO",
  "TOTAL PAGADO",
  "PENDIENTE DE PAGAR",
  "CONCEPTO",
  "OBSERVACIONES",
  "ORIGEN",
  "ORDEN DE COMPRA",
  "PROYECTO",
];

class ReporteConsecutivoFacturacion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoClientes: null,
    todasClientes: null,
    facturas: [],
    totales: null,
    empresa: null,
    periodo: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasClientes: res.data,
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().startOf("month"), moment().endOf("month")],
      clientes: 0,
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesAdministrativos/reporteConsecutivoFacturacion",
        {
          fechaInicial: values.periodo[0].startOf("day").toISOString(),
          fechaFinal: values.periodo[1].endOf("day").toISOString(),
          clientes: values.clientes || 0,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            facturas: res.data.facturas || [],
            totales: res.data.totales,
            empresa: res.data.empresa,
            periodo: res.data.periodo,
            loading: false,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    const { facturas, totales, periodo } = this.state;
    const HEADER_COLOR = "D9D9D9";
    const TITLE_COLOR = "BDD7EE";
    const TOTAL_COLOR = "F8CBAD";
    const RED = "C00000";
    const NUM_COLS = HEADERS.length;
    // Formato Contabilidad: el signo de pesos queda pegado al borde izquierdo
    // de la celda y el numero al borde derecho, en vez de ir junto al numero.
    const FORMATO_CONTABILIDAD = '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';

    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const titleStyle = {
      font: { bold: true, sz: 13 },
      fill: { fgColor: { rgb: TITLE_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const headerStyle = {
      font: { bold: true, sz: 10 },
      fill: { fgColor: { rgb: HEADER_COLOR } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const cellStyle = { alignment: { vertical: "center" }, border };
    const moneyStyle = {
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const moneyRedStyle = {
      font: { color: { rgb: RED } },
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const dashStyle = { alignment: { horizontal: "center", vertical: "center" }, border };
    const totalLabelStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const totalMoneyStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };
    const totalMoneyRedStyle = {
      font: { bold: true, color: { rgb: RED } },
      fill: { fgColor: { rgb: TOTAL_COLOR } },
      alignment: { horizontal: "right", vertical: "center" },
      numFmt: FORMATO_CONTABILIDAD,
      border,
    };

    // xlsx-js-style no infiere el tipo de celda cuando ya se le pasa un
    // objeto { v, s } armado - sin "t" explicito, escribe el numero como
    // texto y Excel no puede aplicarle el formato de moneda (queda con el
    // triangulo verde de "numero guardado como texto").
    const moneyCell = (value, redStyle) => {
      if (!value) return { v: "-", s: dashStyle };
      return { v: value, t: "n", s: redStyle && value > 0 ? moneyRedStyle : moneyStyle };
    };

    const estatusCellStyle = {
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };
    const estatusCanceladoStyle = {
      font: { color: { rgb: RED }, bold: true },
      alignment: { horizontal: "center", vertical: "center" },
      border,
    };

    const rows = [];
    const merges = [];

    const tituloRow = rows.length;
    rows.push(
      Array.from({ length: NUM_COLS }, (_, i) => ({
        v: i === 0 ? "CONSECUTIVO DE FACTURACION" : "",
        s: titleStyle,
      }))
    );
    merges.push({ s: { r: tituloRow, c: 0 }, e: { r: tituloRow, c: NUM_COLS - 1 } });

    const subtituloRow = rows.length;
    const anio = moment(periodo && periodo.fechaInicial).format("YYYY");
    rows.push(
      Array.from({ length: NUM_COLS }, (_, i) => ({
        v: i === 0 ? `CONSECUTIVO FACTURACION CORRESPONDIENTE AL EJERCICIO ${anio}` : "",
        s: titleStyle,
      }))
    );
    merges.push({ s: { r: subtituloRow, c: 0 }, e: { r: subtituloRow, c: NUM_COLS - 1 } });

    rows.push(HEADERS.map((h) => ({ v: h, s: headerStyle })));

    const colorear = debeColorear(facturas);
    // Agrega el fondo del tipo a la celda sin perder su borde, formato ni fuente.
    const conFondo = (celda, rgb) =>
      rgb ? { ...celda, s: { ...celda.s, fill: { fgColor: { rgb } } } } : celda;

    facturas.forEach((f) => {
      const fondo = colorear && TIPOS[f.tipo] ? TIPOS[f.tipo].color : null;
      const fila = [
        { v: f.estatus || "", s: f.cancelado ? estatusCanceladoStyle : estatusCellStyle },
        { v: f.fecha || "", s: cellStyle },
        { v: f.folio || "", s: cellStyle },
        { v: f.razonSocial || "", s: cellStyle },
        { v: f.vendedor || "", s: cellStyle },
        moneyCell(f.importe),
        moneyCell(f.descuento),
        moneyCell(f.iva),
        moneyCell(f.total),
        moneyCell(f.nc),
        moneyCell(f.totalAPagar),
        { v: f.fechaPago || "", s: dashStyle },
        moneyCell(f.totalPagado),
        moneyCell(f.pendienteDePagar, true),
        { v: f.concepto || "", s: cellStyle },
        { v: f.observaciones || "", s: cellStyle },
        { v: f.origen || "", s: cellStyle },
        { v: f.ordenDeCompra || "", s: cellStyle },
        { v: f.proyecto || "", s: cellStyle },
      ];
      rows.push(fila.map((celda) => conFondo(celda, fondo)));
    });

    const totalesRow = rows.length;
    const t = totales || {};
    rows.push([
      { v: "TOTALES", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: t.importe || 0, t: "n", s: totalMoneyStyle },
      t.descuento ? { v: t.descuento, t: "n", s: totalMoneyStyle } : { v: "-", s: totalLabelStyle },
      { v: t.iva || 0, t: "n", s: totalMoneyStyle },
      { v: t.total || 0, t: "n", s: totalMoneyStyle },
      t.nc ? { v: t.nc, t: "n", s: totalMoneyStyle } : { v: "-", s: totalLabelStyle },
      { v: t.totalAPagar || 0, t: "n", s: totalMoneyStyle },
      { v: "", s: totalLabelStyle },
      { v: t.totalPagado || 0, t: "n", s: totalMoneyStyle },
      { v: t.pendienteDePagar || 0, t: "n", s: t.pendienteDePagar > 0 ? totalMoneyRedStyle : totalMoneyStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
      { v: "", s: totalLabelStyle },
    ]);
    merges.push({ s: { r: totalesRow, c: 0 }, e: { r: totalesRow, c: 4 } });

    if (t.totalCancelado) {
      const canceladoRow = rows.length;
      rows.push([
        { v: `De los cuales, facturas canceladas: ${dineroDisabledMask(t.totalCancelado)}`, s: { font: { bold: true, color: { rgb: RED } } } },
        ...Array.from({ length: NUM_COLS - 1 }, () => ({ v: "", s: {} })),
      ]);
      merges.push({ s: { r: canceladoRow, c: 0 }, e: { r: canceladoRow, c: NUM_COLS - 1 } });
    }

    if (colorear) {
      rows.push(Array.from({ length: NUM_COLS }, () => ({ v: "", s: {} })));
      const simbologia = [
        { v: "SIMBOLOGÍA:", s: { font: { bold: true }, alignment: { vertical: "center" } } },
        ...tiposPresentes(facturas).map((tipo) =>
          conFondo(
            { v: TIPOS[tipo].label, s: { alignment: { horizontal: "center", vertical: "center", wrapText: true }, border } },
            TIPOS[tipo].color
          )
        ),
      ];
      rows.push([
        ...simbologia,
        ...Array.from({ length: NUM_COLS - simbologia.length }, () => ({ v: "", s: {} })),
      ]);
    }

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!merges"] = merges;
    worksheet["!cols"] = [
      { wch: 12 },
      { wch: 12 },
      { wch: 14 },
      { wch: 28 },
      { wch: 24 },
      { wch: 13 },
      { wch: 12 },
      { wch: 12 },
      { wch: 13 },
      { wch: 10 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 16 },
      { wch: 40 },
      { wch: 30 },
      { wch: 30 },
      { wch: 18 },
      { wch: 25 },
    ];
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Consecutivo Facturacion");
    XLSXStyle.writeFile(
      workbook,
      `Consecutivo_Facturacion_${moment().locale("es").format("DD-MM-YYYY")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Estatus",
        dataIndex: "estatus",
        key: "estatus",
        width: 100,
        align: "center",
        render: (v, record) =>
          record.cancelado ? (
            <span style={{ color: "#cf1322", fontWeight: "bold" }}>{v}</span>
          ) : (
            v
          ),
      },
      { title: "Fecha", dataIndex: "fecha", key: "fecha", width: 100 },
      { title: "Folio", dataIndex: "folio", key: "folio", width: 120 },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        width: 180,
        ellipsis: true,
      },
      {
        title: "Razón Social",
        dataIndex: "razonSocial",
        key: "razonSocial",
        width: 220,
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        width: 180,
        ellipsis: true,
        render: (v, record) => (record.isTotal ? "" : v || "-"),
      },
      {
        title: "Importe",
        dataIndex: "importe",
        key: "importe",
        width: 110,
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "Descuento",
        dataIndex: "descuento",
        key: "descuento",
        width: 110,
        align: "right",
        render: (v) => (v ? dineroDisabledMask(v) : "-"),
      },
      {
        title: "IVA",
        dataIndex: "iva",
        key: "iva",
        width: 110,
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 110,
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "NC",
        dataIndex: "nc",
        key: "nc",
        width: 100,
        align: "right",
        render: (v) => (v ? dineroDisabledMask(v) : "-"),
      },
      {
        title: "Total a Pagar",
        dataIndex: "totalAPagar",
        key: "totalAPagar",
        width: 130,
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "Fecha de Pago",
        dataIndex: "fechaPago",
        key: "fechaPago",
        width: 120,
        render: (v) => v || "-",
      },
      {
        title: "Total Pagado",
        dataIndex: "totalPagado",
        key: "totalPagado",
        width: 130,
        align: "right",
        render: (v) => dineroDisabledMask(v || 0),
      },
      {
        title: "Pendiente de Pagar",
        dataIndex: "pendienteDePagar",
        key: "pendienteDePagar",
        width: 150,
        align: "right",
        render: (v) =>
          v > 0 ? (
            <span style={{ color: "#cf1322" }}>{dineroDisabledMask(v)}</span>
          ) : (
            "-"
          ),
      },
      {
        title: "Observaciones",
        dataIndex: "observaciones",
        key: "observaciones",
        width: 180,
        ellipsis: true,
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: 260,
        ellipsis: true,
      },
      {
        title: "Origen",
        dataIndex: "origen",
        key: "origen",
        width: 220,
        ellipsis: true,
      },
      {
        title: "Orden de Compra",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        width: 150,
        ellipsis: true,
        render: (v) => v || "-",
      },
    ];

    const { facturas, totales } = this.state;

    // Sin mezcla de tipos se deja rowClassName en undefined para que TableItem
    // use su zebra de siempre y la tabla se vea igual que antes.
    const colorear = debeColorear(facturas);
    const rowClassName = colorear
      ? (record) => (record.isTotal || !TIPOS[record.tipo] ? "default" : TIPOS[record.tipo].className)
      : undefined;

    const filaTotales = totales
      ? {
          key: "totales",
          isTotal: true,
          fecha: "",
          folio: "",
          proyecto: "",
          razonSocial: "TOTALES",
          vendedor: "",
          importe: totales.importe,
          descuento: totales.descuento,
          iva: totales.iva,
          total: totales.total,
          nc: totales.nc,
          totalAPagar: totales.totalAPagar,
          fechaPago: "",
          totalPagado: totales.totalPagado,
          pendienteDePagar: totales.pendienteDePagar,
          observaciones: "",
          concepto: "",
          origen: "",
          ordenDeCompra: "",
        }
      : null;

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteConsecutivoFacturacion"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().startOf("month"), moment().endOf("month")],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Consecutivo de Facturación"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {facturas.length > 0 && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                marginBottom: 10,
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 10,
                marginBottom: 15,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              {colorear && (
                <Space size="middle" wrap style={{ marginBottom: 10 }}>
                  {tiposPresentes(facturas).map((tipo) => (
                    <Space key={tipo} size={6}>
                      <span
                        style={{
                          display: "inline-block",
                          width: 14,
                          height: 14,
                          borderRadius: 3,
                          border: "1px solid #d9d9d9",
                          backgroundColor: TIPOS[tipo].color ? `#${TIPOS[tipo].color}` : "#ffffff",
                        }}
                      />
                      <span>{TIPOS[tipo].label}</span>
                    </Space>
                  ))}
                </Space>
              )}
              <TableItem
                rowKey={(record, index) => record.key || index}
                columns={columns}
                dataSource={filaTotales ? [...facturas, filaTotales] : facturas}
                size="small"
                pagination={false}
                scroll={{ x: "max-content" }}
                rowClassName={rowClassName}
                onRow={(record) =>
                  record.isTotal
                    ? { style: { backgroundColor: "#FCE4D6", fontWeight: "bold" } }
                    : {}
                }
              />
              {totales && totales.totalCancelado > 0 && (
                <p style={{ marginTop: 10, marginBottom: 0, color: "#cf1322", fontWeight: "bold" }}>
                  De los cuales, facturas canceladas: {dineroDisabledMask(totales.totalCancelado)}
                </p>
              )}
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteConsecutivoFacturacion);
